import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MetaService } from '@app/core/services/meta.service';
import { NavItem } from '@app/interfaces/nav-item';
import { NavComponent } from '@app/layout/nav/nav.component';

@Component({
  selector: 'app-licensing-policy-page',
  templateUrl: './licensing-policy.page.html',
  styleUrls: ['./licensing-policy.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NavComponent],
})
export class LicensingPolicyPage implements OnInit {
  constructor(private metaService: MetaService) {}

  protected navItems: NavItem[] = [{ label: 'Licensing policy' }];

  ngOnInit(): void {
    const metadata = {
      title: 'ImageBase.pro – Licensing Policy & Usage Rights',
      description:
        "Understand ImageBase.pro's licensing policy, including permitted usage, restrictions, and guidelines for using our stock images in commercial and personal projects.",
      keywords:
        'ImageBase.pro licensing policy, image usage rights, stock photo license, commercial use, royalty-free images, copyright policy',
    };

    this.metaService.setMetadata(metadata);
  }
}
